export default __webpack_public_path__ + "static/media/bgGradient.a45075d9.svg";